import { z } from 'zod'

export const FormSectionSchema = z.object({
  id: z.string(),
  type: z.literal('form').default('form'),
  title: z.string().optional(),
  fields: z.array(z.string()),
})

export type FormSection = z.infer<typeof FormSectionSchema>
